import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BusinessUserFilter, BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';
import { EnvironmentService } from 'src/app/services/environment.service'
import { MatDialog } from '@angular/material/dialog';
import { ImageGalleryComponent } from '../../../../shared/image-gallery/image-gallery.component';
import { StockImagesGalleryComponent } from '../../../../shared/stock-images-gallery/stock-images-gallery.component';
import { AttachmentService } from 'src/app/services/attachment.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { AttachmentResource } from 'src/app/interfaces/attachment-resource';
import { Interest } from 'src/app/interfaces/interest';
import { EventResource } from 'src/app/interfaces/event-resource';
import { ActivatedRoute, Router } from '@angular/router';
import * as uuid from 'uuid';

import { ClubstateService } from 'src/app/services/clubstate.service';
import { Clubstate } from 'src/app/interfaces/clubstate';
import { MatRadioChange } from '@angular/material/radio';
import { DateAdapter } from '@angular/material/core';/**
* The Options used for sorting
*/
import { TaxRate } from 'src/app/enums/tax-rate';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessEntityResource } from 'src/app/interfaces/business-entity-resource';
interface SortOption {
  /**
   * The Value of the Filteroption
   */
  value: string;
  /**
   * The viewValue (visible to the User) of the Filteroption
   */
  viewValue: string;
  /**
   * Is the  Filteroption disabled
   */
  state?: boolean;
}
@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  /**
   * The Type of Event
   */
  type: string = "";
  /**
   * The Image Files
   */
  files: File[] = [];
  /**
   * The Interest to the Event
   */
  interests = [];
  /**
   * The Partners to the Event;
   */
  partners = []
  /**
   * The Form to add a new Event
   */
  addForm: UntypedFormGroup;
  /**
   * The Form for the   interest of the Event
   */
  interestForm: UntypedFormGroup;
  /**
   * The Form for the Price of the Event
   */
  priceForm: UntypedFormGroup;
  /**
   * The Form for the Adress of the Event
   */
  addressForm: UntypedFormGroup;
  /**
   * The Form for the Vouchers of the Event
   */
  voucherCreationForm: UntypedFormGroup;
  /**
   * The Form for the Limitation of the Event
   */
  limitationForm: UntypedFormGroup;
  /**
   * The Form for the Date of the Event
   */
  dateForm: UntypedFormGroup;
  /**
   * The Form for the Button of the Event
   */
  buttonConfigForm: UntypedFormGroup;
  /**
   * The Form for the Details of the Event
   */
  detailsForm: UntypedFormGroup;
  /**
   * Should the Image be changed
   */
  changeImage: boolean = false;
  /**
   * The Types of event
   */
  public eventStates = [
    { value: 'SERVICE_PLUS', viewValue: 'Exklusiv', state: false },
    { value: 'MONETARY', viewValue: 'Preisvorteil', state: false },
    { value: 'EXTERNAL_EVENT', viewValue: 'Partneraktion' },
    { value: 'RAFFLE', viewValue: 'Gewinnspiel' },
    //MONETARY_PAYMENT is not officily supported as a type => just in frontend to differ events with mwst
    // { value: 'MONETARY_PAYMENT', viewValue: 'Bezahlpflichtige Aktion', state: false },
    // { value: 'EXTERNAL_EVENT', viewValue: 'Externer Partner', state: true }
  ];
  /**
   * The Options of the Event
   */
  public voucherOptions = [
    { value: 'GATES', viewValue: 'Gates Gutscheincodes', state: false },
    { value: 'EXTERNAL_SINGLE_KEY', viewValue: 'Aktionspartnercodes (einer)', state: false },
    { value: 'EXTERNAL_KEY_LIST', viewValue: 'Aktionspartnercodes (mehrere)', state: false },
  ];
  /**
   * The Limit of the Event
   */
  public targetGroupOptions = [
    { value: 'WITHOUT_LIMIT', viewValue: 'Ohne Einschränkung', state: false },
    { value: 'ADULT', viewValue: 'Erwachsene (>= 18 Jahre)', state: false },
    { value: 'YOUTH', viewValue: 'unter 18-jährige', state: false },
    { value: 'CHILDREN', viewValue: 'Kinder (6-12 Jahre)', state: false },
    { value: 'CHILDREN2', viewValue: 'Kinder 2 (8-14 Jahre)', state: false },
    { value: 'WOMAN_ONLY', viewValue: 'Frauen (>=18 Jahre)', state: false },
    { value: 'MAN_ONLY', viewValue: 'Männer (>= 18 Jahre)', state: false },
    { value: 'TEENAGER', viewValue: 'Jugendliche (13-17 Jahre)', state: false },
    { value: 'BABYS', viewValue: 'Kleinkinder (0-5 Jahre)', state: false },
  ];
  /**
   * The Eventstate of the Event
   */
  public event_States = [
    { value: "CREATED", viewValue: "In Freigabe" },
    { value: "DRAFT", viewValue: "Entwurf" },
    { value: "PREVIEW", viewValue: "Vorschau" },
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "HIDDEN", viewValue: "Versteckt" },
    { value: "CANCELLED", viewValue: "Abgelehnt" },
    { value: "EXPIRED", viewValue: "Abgelaufen" },
    { value: "ARCHIVED", viewValue: "Archiviert" },
    { value: "DELETED", viewValue: "Gelöscht" }
  ]
  /**
   * The Priooptions of the Event
   */
  public prioOptions = [
    { value: '0', viewValue: 'Standard', state: false },
    { value: '1000', viewValue: 'Top-Angebot 1', state: false },
    { value: '930', viewValue: 'Top-Angebot 2', state: false },
    { value: '920', viewValue: 'Top-Angebot 3', state: false },
    { value: '910', viewValue: 'Top-Angebot 4', state: false },
    { value: '900', viewValue: 'Top-Angebot 5', state: false },
    { value: '890', viewValue: 'Top-Angebot 6', state: false },
    { value: '880', viewValue: 'Top-Angebot 7', state: false },
    { value: '870', viewValue: 'Top-Angebot 8', state: false },
    { value: '860', viewValue: 'Top-Angebot 9', state: false },
    { value: '850', viewValue: 'Top-Angebot 10', state: false },
    { value: '840', viewValue: 'Top-Angebot 11', state: false },
    { value: '830', viewValue: 'Top-Angebot 12', state: false },
    { value: '820', viewValue: 'Top-Angebot 13', state: false },
    { value: '810', viewValue: 'Top-Angebot 14', state: false },
    { value: '800', viewValue: 'Top-Angebot 15', state: false },
    { value: '790', viewValue: 'Top-Angebot 16', state: false },
    { value: '780', viewValue: 'Top-Angebot 17', state: false },
    { value: '770', viewValue: 'Top-Angebot 18', state: false },
    { value: '760', viewValue: 'Top-Angebot 19', state: false },
    { value: '750', viewValue: 'Top-Angebot 20', state: false },
    { value: '740', viewValue: 'Top-Angebot 21', state: false },
    { value: '730', viewValue: 'Top-Angebot 22', state: false },
    { value: '720', viewValue: 'Top-Angebot 23', state: false },
    { value: '710', viewValue: 'Top-Angebot 24', state: false },
    { value: '700', viewValue: 'Top-Angebot 25', state: false },
    { value: '690', viewValue: 'Top-Angebot 26', state: false },
    { value: '680', viewValue: 'Top-Angebot 27', state: false },
    { value: '670', viewValue: 'Top-Angebot 28', state: false },
    { value: '660', viewValue: 'Top-Angebot 29', state: false },
    { value: '650', viewValue: 'Top-Angebot 30', state: false },
  ]
  /**
   * The options of the Taxrate Dropdown
   */
  public taxRates = [
    { value: 'MWST_5', viewValue: '5%', state: false },
    { value: 'MWST_7', viewValue: '7%', state: false },
    { value: 'MWST_16', viewValue: '16', state: false },
    { value: 'MWST_19', viewValue: '19', state: false }
  ]
  /**
   * The Clubstates of an event (CURRENTLY ONLY BIELEFELD)
   */
  clubstates: Array<Clubstate> = [];
  /**
   * The Taxrate of the Event;
   */
  taxRate: TaxRate;
  /**
   * The Properties for the EventImage
   */
  imageProperties = [
    { key: 'logo', value: null, hint: 'Format: 800 x 500, Typ: .png', hasChanged: false },
  ];
  /**
   * The Array of selected Checkboxes
   */
  interestCheckboxOptions: Array<any> = []
  /**
   * Show the event text as html
   */
  showAsHtml: boolean = false;
  /**
   * Init the Form
   * @param eventService 
   * @param fb 
   * @param environmentService 
   * @param dialog 
   * @param attachmentService 
   * @param overlayService 
   * @param router 
   * @param route 
   * @param clubstateService 
   * @param dateAdapter 
   */
  constructor(
    private eventService: EventService,
    private fb: UntypedFormBuilder,
    private environmentService: EnvironmentService,
    private dialog: MatDialog,
    private attachmentService: AttachmentService,
    private overlayService: OverlayService,
    private router: Router,
    private route: ActivatedRoute,
    private clubstateService: ClubstateService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale('de-DE');
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.type = params['id'];
    })

    this.clubstateService.getAllStatesForClientID().subscribe({
      next: (states: Array<any>) => {
        this.clubstates = states;
      },
      error: err => {
        console.log(err)
      }
    })


    this.addForm = this.fb.group({
      image: ['', [Validators.required]],
      eventDiscount: ['', [Validators.required]],
      eventPartner: ['', [Validators.required]],
      title: ['', [Validators.required]],
      eventLimit: ['WITHOUT_LIMIT', [Validators.required]],
      state: ['CREATED', [Validators.required]],
      voucherKeyStrategy: ['GATES', [Validators.required]],
      description: ['', [Validators.required]],
      clientRef: [this.environmentService.getClientId(), [Validators.required]],
      savingInPercent: [, []],
      regularPriceMoney: [null, []],
      eventPriceMoney: [null, []],
      taxRate: [null, []],
      accessCode: [null, []],
      //   customerValues: [null, [Validators.required]],
    })

    this.addressForm = this.fb.group({
      street: ['', []],
      postcode: ['', []],
      city: ['', []],
    })

    this.interestForm = this.fb.group({
      interests: this.fb.array([])
    })

    this.buttonConfigForm = this.fb.group({
      buttonCaption: ['', []],
      buttonExternalLink: ['', []],
    })

    this.priceForm = this.fb.group({
      type: ['1', []],
    })

    this.eventService.getInterests().subscribe((interests: any) => {
      this.interests = interests;
      this.interests.forEach(interest => {
        this.interestCheckboxOptions.push({ name: interest.name, value: interest.publicId })
      });
    })

    this.eventService.getPartners().subscribe((value:PagedResources<BusinessEntityResource>) => {
      this.partners = value.content
    })

    if (this.type == 'advanced') {
      this.voucherCreationForm = this.fb.group({
        voucherKeyStrategy: ['GATES', []],
        reservationValidTime: [0, []],
        validityDate: [, []],
        reservationClue: ['', []],
        sendReservationMail: [false, []],
        showReservationQR: [false, []],
        autoAttendance: [false, []],
        sendStornoMail: [false, []],
        validityPeriod: ['true', []],
      })

      this.limitationForm = this.fb.group({
        perPersonQuota: ['0', []],
        reservationQuota: ['0', []],
        groupQuota: ['0', []],
      })

      this.dateForm = this.fb.group({
        startDate: ['', [Validators.required]],
        endDate: ['', [Validators.required]],
        startTime: ['', []],
        endTime: ['', []],
      });
      this.detailsForm = this.fb.group({
        additionalInformationWebsite: ['', []],
        scheduleDescription: ['', []],
        location: ['', []],
        priority: ['0', []],
        eventLimit: ['WITHOUT_LIMIT', []],
      })
      this.detailsForm.controls['location'].disable();
    }
  }
  /**
   * Jump to the updated Adress Input
   */
  jumpToAddress() {
    document.getElementById('address')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
  /**
   * Select an Image
   * @param event 
   */
  onSelect(event) {
    this.files.push(...event.addedFiles);
    if (this.files.length != 0) {
      this.attachmentService.createAttachment(this.environmentService.getClientId(), this.files[0]).subscribe(attachment => {
        this.addForm.patchValue({
          image: attachment
        })
        this.changeImage = false;
      })
    }
  }
  /**
   * Remove the Image
   * @param event 
   */
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  /**
   * Create an Event
   * @returns 
   */
  createEvent() {
    this.addForm.markAllAsTouched();
    if (this.type == 'advanced') {
      this.voucherCreationForm.markAllAsTouched();
      this.limitationForm.markAllAsTouched();
      this.dateForm.markAllAsTouched();
      this.priceForm.markAllAsTouched();
      this.addressForm.markAllAsTouched();
    }

    if (this.addForm.invalid || this.interestForm.invalid) {
      return
    }

    if (this.type == 'advanced') {
      let tempEvent: EventResource = {
        image: this.addForm.value.image,
        eventDiscount: this.addForm.value.eventDiscount,
        eventPartner: this.addForm.value.eventPartner,
        title: this.addForm.value.title,
        accessCode: this.addForm.value?.accessCode,
        state: this.addForm.value.state,
        description: this.addForm.value.description,
        clientRef: this.environmentService.getClientId(),
        savingInPercent: this.addForm.value.savingInPercent,
        //Voucherlimitation
        voucherKeyStrategy: this.voucherCreationForm.value.voucherKeyStrategy,
        reservationClue: this.voucherCreationForm.value.reservationClue,
        sendReservationMail: this.voucherCreationForm.value.sendReservationMail,
        reservationValidTime: this.voucherCreationForm.value.reservationValidTime,
        validityDate: this.voucherCreationForm.value.validityDate,
        validityPeriod: this.voucherCreationForm.value.validityPeriod,
        autoAttendance: this.voucherCreationForm.value.autoAttendance,
        sendStornoMail: this.voucherCreationForm.value.sendStornoMail,
        showReservationQR: this.voucherCreationForm.value.showReservationQR,

        //limitation
        perPersonQuota: this.limitationForm.value.perPersonQuota,
        groupQuota: this.limitationForm.value.groupQuota,
        reservationQuota: this.limitationForm.value.reservationQuota,
        //Date Limitation
        startDate: new Date(this.dateForm.value.startDate).getTime(),
        endDate: new Date(this.dateForm.value.endDate).getTime(),
        start: new Date(this.dateForm.value.startDate).toISOString().split('T')[0],
        end: new Date(this.dateForm.value.endDate).toISOString().split('T')[0],
        //DETAILS Limitation
        scheduleDescription: this.detailsForm.value.scheduleDescription,
        //Deprecated GSD-98
        // location: this.detailsForm.value.location,
        additionalInformationWebsite: this.detailsForm.value.additionalInformationWebsite,
        priority: this.detailsForm.value.priority,
        eventLimit: this.detailsForm.value.eventLimit,
        reservationRequired: true,
        buttonCaption: this.buttonConfigForm.getRawValue().buttonCaption,
        buttonExternalLink: this.buttonConfigForm.getRawValue().buttonExternalLink,

        // customerValues: "[" + String(this.addForm.value.customerValues) + "]",
        address: {
          street: this.addressForm.value.street,
          city: this.addressForm.value.city,
          postcode: this.addressForm.value.postcode
        }

      }

      if (this.addForm.value.eventDiscount != 'MONETARY') {

      } else {
        if (this.priceForm.value.type == '1') {
          tempEvent.regularPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.regularPriceMoney
          }
          tempEvent.eventPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.eventPriceMoney
          }
        }
      }
      this.eventService.createEvent(tempEvent).subscribe((returnFromCreate: EventResource) => {
        if (returnFromCreate) {
          this.overlayService.openSnackBar("Aktion erfolgreich erstellt!");
          this.movebacktoOverview();
        }
        this.interestForm.value.interests.forEach(element => {
          let tempInteres: Interest = {
            'name': element.name,
            'publicId': element.value
          }
          this.eventService.addInterestToEvent(returnFromCreate.publicId, tempInteres).subscribe(value => {
            console.log("addInterestToEvent", value);
          })
        });
      })
    } else {
      let tempEvent: EventResource = {
        image: this.addForm.value.image,
        eventDiscount: this.addForm.value.eventDiscount,
        eventPartner: this.addForm.value.eventPartner,
        title: this.addForm.value.title,
        eventLimit: this.addForm.value.eventLimit,
        state: this.addForm.value.state,
        description: this.addForm.value.description,
        clientRef: this.environmentService.getClientId(),
        savingInPercent: this.addForm.value.savingInPercent,
        voucherKeyStrategy: this.addForm.value.voucherKeyStrategy,
        accessCode: this.addForm.value?.accessCode,
        // customerValues: "[" + String(this.addForm.value.customerValues) + "]",
        startDate: new Date(),
        endDate: new Date(),
        reservationRequired: true,
        address: {
          street: this.addressForm.value.street,
          city: this.addressForm.value.city,
          postcode: this.addressForm.value.postcode
        }
      }

      if (this.addForm.value.eventDiscount != 'MONETARY') {

      } else {
        if (this.priceForm.value.type == '1') {
          tempEvent.regularPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.regularPriceMoney
          }
          tempEvent.eventPriceMoney = {
            "currency": "EUR",
            "amount": this.addForm.value.eventPriceMoney
          }
        }
      }
      this.eventService.createEvent(tempEvent).subscribe((returnFromCreate: EventResource) => {
        console.log("returnFromCreate", returnFromCreate)
        if (returnFromCreate) {
          this.overlayService.openSnackBar("Aktion erfolgreich erstellt!");
          this.movebacktoOverview();
        }
        this.interestForm.value.interests.forEach(element => {
          let tempInteres: Interest = {
            'name': element.name,
            'publicId': element.value
          }
          this.eventService.addInterestToEvent(returnFromCreate.publicId, tempInteres).subscribe(value => {
            console.log("addInterestToEvent", value);
          })
        });
      })
    }
  }
  /**
   * Open the Gallery to select an Image
   * @param property 
   */
  openImageGallery(property) {
    const dialogRef = this.dialog.open(ImageGalleryComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log("result: ", result);
        this.addForm.controls.image.setValue(result);
        property.value = result.url;
        property.hasChanged = true;
        property.newValue = `${result.clientRef}/attachment/${result.publicId}`;
        this.changeImage = false;
      }
    });
  }
  /**
   * Open the Stockimages Gallery
   * @deprecated
   */
  openStockImageGallery() {
    const dialogRef = this.dialog.open(StockImagesGalleryComponent, {
      minWidth: '25vw',
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        const image = await fetch(result.largeImageURL)
        const imageBlog = await image.blob()
        const imageURL = URL.createObjectURL(imageBlog)

        const link = document.createElement('a')
        link.href = imageURL
        link.download = `${result.id}.jpeg`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link);
        this.changeImage = true;
      }
    });
  }
  /**
   * Update the Interestsform
   * @param e 
   */
  onCheckboxChange(e) {
    const checkArray: UntypedFormArray = this.interestForm.get('interests') as UntypedFormArray;
    if (e.checked) {
      checkArray.push(new UntypedFormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value == e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }
  /**
   *  move to the Event Overviewpage
   */
  movebacktoOverview() {
    this.router.navigateByUrl('caseworker/event')
  }
  /**
   * move to the ExpertView
   */
  moveToExpertView() {
    this.router.navigateByUrl('caseworker/event/overview/add/advanced')
  }
  /**
   * Toggle the Image Upload
   */
  toogleImageUpload() {
    this.changeImage = !this.changeImage;
  }

  /**
   * Update the Validators of the Form based on the Input for the Type of Event
   */
  changeEvenType() {
    switch (this.addForm.value.eventDiscount) {
      case 'SERVICE_PLUS': {
        break;
      }
      case 'MONETARY': {
        if (this.priceForm.getRawValue().type == '1') {
          this.addForm.controls.savingInPercent.removeValidators(Validators.required);
          this.addForm.controls.regularPriceMoney.addValidators(Validators.required);
          this.addForm.controls.eventPriceMoney.addValidators(Validators.required);
          this.addForm.updateValueAndValidity();
        } else if (this.priceForm.getRawValue().type == '2') {
          this.addForm.controls.savingInPercent.addValidators(Validators.required);
          this.addForm.controls.regularPriceMoney.removeValidators(Validators.required);
          this.addForm.controls.eventPriceMoney.removeValidators(Validators.required);
          this.addForm.updateValueAndValidity();
        }
        break;
      }
      case 'MONETARY_PAYMENT': {
        if (this.priceForm.getRawValue().type == '1') {
          this.addForm.controls.savingInPercent.removeValidators(Validators.required);
          this.addForm.controls.regularPriceMoney.addValidators(Validators.required);
          this.addForm.controls.eventPriceMoney.addValidators(Validators.required);
          this.addForm.controls.taxRate.addValidators(Validators.required);
          this.addForm.updateValueAndValidity();
        } else if (this.priceForm.getRawValue().type == '2') {
          this.addForm.controls.savingInPercent.addValidators(Validators.required);
          this.addForm.controls.regularPriceMoney.removeValidators(Validators.required);
          this.addForm.controls.eventPriceMoney.removeValidators(Validators.required);
          this.addForm.controls.taxRate.removeValidators(Validators.required);
          this.addForm.updateValueAndValidity();
        }
        break;
      }
      case 'EXTERNAL_EVENT': {
        break;
      }
      default: {
        break;
      }
    }
  }
  /**
   * Update the Validators of the Form based on the Input for the Type of Discount
   */
  changeDiscountType() {
    if (this.priceForm.getRawValue().type == '1') {
      this.addForm.controls.savingInPercent.removeValidators(Validators.required);
      this.addForm.controls.regularPriceMoney.addValidators(Validators.required);
      this.addForm.controls.eventPriceMoney.addValidators(Validators.required);
      this.addForm.controls.savingInPercent.updateValueAndValidity();
      this.addForm.controls.regularPriceMoney.updateValueAndValidity();
      this.addForm.controls.eventPriceMoney.updateValueAndValidity();
    } else if (this.priceForm.getRawValue().type == '2') {
      this.addForm.controls.savingInPercent.addValidators(Validators.required);
      this.addForm.controls.regularPriceMoney.removeValidators(Validators.required);
      this.addForm.controls.eventPriceMoney.removeValidators(Validators.required);
      this.addForm.controls.savingInPercent.updateValueAndValidity();
      this.addForm.controls.regularPriceMoney.updateValueAndValidity();
      this.addForm.controls.eventPriceMoney.updateValueAndValidity();
    }
  }
  /**
   * Update the Validators of the Form based on the Input for the Time
   * @param event 
   */
  changeVoucherTime(event: MatRadioChange) {
    if (event.value == 'true') {
      this.voucherCreationForm.controls['validityDate'].reset();
      this.voucherCreationForm.controls['reservationValidTime'].addValidators([Validators.required]);
      this.voucherCreationForm.controls['reservationValidTime'].patchValue(0);
      this.voucherCreationForm.controls['reservationValidTime'].updateValueAndValidity();
      this.voucherCreationForm.controls['validityDate'].removeValidators([Validators.required]);
      this.voucherCreationForm.controls['validityDate'].updateValueAndValidity();
    } else {
      this.voucherCreationForm.controls['reservationValidTime'].reset()
      this.voucherCreationForm.controls['validityDate'].addValidators([Validators.required]);
      this.voucherCreationForm.controls['validityDate'].updateValueAndValidity();
      this.voucherCreationForm.controls['reservationValidTime'].removeValidators([Validators.required]);
      this.voucherCreationForm.controls['reservationValidTime'].updateValueAndValidity();
    }
  }
  /**
   * getaddFormControls
   */
  get getaddFormControls() {
    return this.addForm.controls;
  }
  /**
 * getLimitationForm
 */
  get getLimitationForm() {
    return this.limitationForm.controls
  }
  /**
   * getVoucherCreationForm
   */
  get getVoucherCreationForm() {
    return this.voucherCreationForm.controls
  }

}
